import React from "react";
import Input from "../../../../Input";
import Dropdown from "../../../../Dropdown";
import pixabayLogo from "../../../../../assets/images/pixabay.svg";
import giphyLogo from "../../../../../assets/images/giphy.svg";
import { IconButton } from "@mui/material";
import { Search } from "@mui/icons-material";
import { onActivateKeyDown } from "../../../../../utils/keyboardActivate";

function Header({
  selectedEngine,
  handleEngineChange,
  items,
  mediaKeyword,
  handleChangeMediaKeyword,
  fieldPlaceHolder = "Search Media or select a category",
  showIcon = true,
  iconPosition = "start",
  showDropdown = false,
  onSearch,
  mediaType,
}) {
  // gordon-0915-video-block-media-pane-pixabay-embed-first-record-tier:
  // determine which provider logo (if any) to show from the SELECTED ITEM'S
  // OWN title, not a bare numeric coincidence. The old `engineValue === "1"`
  // shortcut assumed key=1 always meant "Images"/Pixabay — true for the image
  // engine list, but video's ONLY engine also happened to use key=1
  // ("Youtube"), so every Video Browse render showed the Pixabay logo/label
  // while actually searching Youtube. Now: Pixabay/Images -> pixabay logo,
  // Gifs -> giphy logo, anything else (e.g. Youtube) -> no provider logo at
  // all, since there's no matching "open in a new tab" affordance for it.
  const selectedItem =
    items &&
    items.find((it) => String(it.value ?? it.key) === String(selectedEngine));
  const engineValue = String(selectedEngine);
  const selectedTitle = String(selectedItem?.title ?? "").toLowerCase();
  const isImagesSelected =
    selectedTitle.includes("pixabay") ||
    selectedTitle.includes("image") ||
    (!selectedItem && engineValue === "1");
  const isGiphySelected = selectedTitle.includes("gif");
  const showProviderLogo = isImagesSelected || isGiphySelected;
  const canNavigateToPixabay =
    isImagesSelected && mediaKeyword && mediaKeyword.trim().length > 2;
  const openPixabaySearch = () => {
    if (!canNavigateToPixabay) return;
    const q = encodeURIComponent(mediaKeyword.trim());
    const basePath = mediaType === "video" ? "videos" : "images";
    window.open(`https://pixabay.com/${basePath}/search/${q}/`, "_blank");
  };
  return (
    <div>
      {showProviderLogo && (
        <div
          style={{ display: "flex", justifyContent: "start", marginBottom: 8 }}
        >
          <img
            role="button"
            tabIndex={canNavigateToPixabay ? 0 : -1}
            aria-disabled={!canNavigateToPixabay}
            aria-label={
              canNavigateToPixabay
                ? "Search Pixabay for this keyword in a new tab"
                : isImagesSelected
                ? "Pixabay"
                : "Giphy"
            }
            src={isImagesSelected ? pixabayLogo : giphyLogo}
            alt={isImagesSelected ? "pixabay" : "giphy"}
            style={{
              height: 32,
              width: 88,
              cursor: canNavigateToPixabay ? "pointer" : "default",
            }}
            title={canNavigateToPixabay ? "Search on Pixabay" : undefined}
            onClick={openPixabaySearch}
            onKeyDown={onActivateKeyDown(
              openPixabaySearch,
              canNavigateToPixabay
            )}
          />
        </div>
      )}
      <div
        style={{
          position: "sticky",
          display: "flex",
          width: "100%",
          gap: 10,
        }}
      >
        {showDropdown && (
          <div style={{ flex: "0 0 25%" }}>
            <Dropdown
              variant="outlined"
              options={(items || []).map((it) => ({
                value: it.value ?? it.key,
                label: it.title ?? it.label,
              }))}
              selectedValue={selectedEngine}
              onChange={(e) => handleEngineChange(e.target.value)}
            />
          </div>
        )}

        <div style={{ flex: showDropdown ? "0 0 55%" : "0 0 85%" }}>
          <Input
            isSearch={true}
            placeholder={fieldPlaceHolder}
            variant={"secondary"}
            value={mediaKeyword}
            onChange={(e) => handleChangeMediaKeyword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                onSearch && onSearch();
              }
            }}
            onClear={() => handleChangeMediaKeyword("")}
            showClearIcon={mediaKeyword.length !== 0}
          />
        </div>

        <div
          style={{
            flex: "0 0 15%",
            display: "flex",
          }}
        >
          <IconButton
            onClick={onSearch}
            aria-label="search"
            style={{
              width: 40,
              height: 35,
              marginTop: 5,
              borderRadius: 4,
              background: "var(--Primary-Purple-500, #9B5AF8)",
              opacity: 1,
              color: "white",
            }}
          >
            <Search fontSize="small" />
          </IconButton>
        </div>
      </div>
    </div>
  );
}

export default Header;
